'use client'

import { cn } from '@/lib/utils'
import { useEffect, useRef, useState } from 'react'
import AnimatedBannerItem from './animated-banner-item'

const SCROLL_SPEED = 80

interface AnimatedBannerProps {
  className?: string
  texts?: string[]
}

const AnimatedBanner = ({ className, texts }: AnimatedBannerProps) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const groupRef = useRef<HTMLUListElement>(null)
  const [repeat, setRepeat] = useState(1)
  const [duration, setDuration] = useState(0)

  useEffect(() => {
    const measure = () => {
      const groupWidth = groupRef.current?.scrollWidth ?? 0
      const containerWidth = containerRef.current?.offsetWidth ?? 0
      if (!groupWidth) return

      const needed = Math.max(1, Math.ceil(containerWidth / groupWidth))
      setRepeat(needed)
      setDuration((needed * groupWidth) / SCROLL_SPEED)
    }

    measure()
    window.addEventListener('resize', measure)
    return () => window.removeEventListener('resize', measure)
  }, [texts])

  if (!texts?.length) return null

  return (
    <div
      ref={containerRef}
      className={cn('w-full overflow-hidden bg-black', className)}
    >
      <div
        className="flex w-max animate-marquee"
        style={duration ? { animationDuration: `${duration}s` } : undefined}
      >
        {[0, 1].map((copy) => (
          <div key={copy} className="flex" aria-hidden={copy === 1}>
            {Array.from({ length: repeat }).map((_, index) => (
              <AnimatedBannerItem
                key={`${copy}-${index}`}
                texts={texts}
                ref={copy === 0 && index === 0 ? groupRef : undefined}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  )
}

export default AnimatedBanner
